module.exports = __webpack_public_path__ + "media/images/weather/301_day-cf2bb71721658cef99ed0ddc13efbbf1.png";